import { handleAxiosError } from "../common/handleAxiosError";
import { projectsApiClient } from "../common/axiosInstanceProjects";
import { IFormData } from "./types";

export const createProject = async (formData: IFormData) => {
  try {
    const data = await projectsApiClient.post("/projects", formData)
    return data;
  } catch (error) {
    handleAxiosError(error, "Error al crear el proyecto");
  }
};
